import { TTableSort } from 'src/components/table/thead/col';

import { TProductShortListSortCol } from './product-short.type';


export type TAccountProductShortListQuery = {
	limit: number;
	offset: number;
	search?: string;
	searchBrandName?: string;
	searchSerialNumber?: string;
	searchProvider?: string;
	searchName?: string;
	sort?: TTableSort;
	sortCol?: TProductShortListSortCol;
	serialNumber: string;
};

export type TAccountProductShortListQueryRequest = {
	limit?: number;
	offset?: number;
	search?: string;
	sort?: string;
	sort_col?: string;
	serial_number?: string;
};

export function adaptAccountProductShortListQueryToRequest(data?: TAccountProductShortListQuery): TAccountProductShortListQueryRequest {
	if (!data) {
		return {};
	}

	const {
		sortCol,
		...restFields
	} = data;

	return {
		sort_col: sortCol,
		...restFields
	};
}

export type TAccountProductShortPayloadRequest = {
	serialNumber: string;
};

export type TAccountProductShortRequest = {
	serial_number: string;
};

export type TAccountProductShortHistoryItem = TAccountProductShortPayloadRequest & {
	date: string;
	key: string;
};

export function adaptAccountProductShortToRequest(data: TAccountProductShortPayloadRequest): TAccountProductShortRequest {
	const {
		serialNumber,
	} = data;

	return {
		serial_number: serialNumber,
	};
}
